/**
 * Границы районов
 */
import regionTerritoriesData from './regionTerritories.json';

export const REGION_TERRITORIES = regionTerritoriesData;

export function getRegionTerritories (regionId) {
  return REGION_TERRITORIES[regionId] || null;
}
